// extracted by mini-css-extract-plugin
export default {"wrapperDropdown":"FMQa8","dropdown":"iDR4u","dropdownItem":"lSCh9","icon":"FdNZ2","dropdownText":"SgQBb"};